export default function existing(props) {
    return {
        name: "existing",
        title: 'Existing mortgage',
        link: `apply/existing`,
        props: props,
        questions: [
            remainingTerm(props),
            lender(props),
            accountNumber(props),
            monthlyPayment(props),
            currentRate(props),
            outstanding(props),
            topUpRequired(props),
            topUpPurpose(props),
            topUpAmount(props)
        ]
    }
}

export function remainingTerm(props) {
    return {
        name: "remainingTerm",
        answer: {
            type: "int",
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 35, message: "35 is the maximum here"}
            }
        },
        label: "Years Remaining",
        text: "How many years are remaining on your mortgage?",
        model: "existing"
    }
}

export function accountNumber(props) {
    return {
        name: "accountNumber",
        answer: {
            type: "text",
            style:{
                textTransform:'uppercase'
            }
        },
        label: "Account Number",
        text: "What is your mortgage account number?",
        model: "existing"
    }
}

export function lender(props) {
    return {
        label: "Current Lender",
        text: "With whom is your mortgage now?",
        name: "lender",
        answer: {
            type: "text"
        },
        model: "existing"
    }
}

export function currentRate(props) {
    return {
        name: "currentRate",
        answer: {
            type: "float",
        },
        label: "Current Rate",
        text: "What is your current interest rate?",
        model: "existing"
    }
}

export function monthlyPayment(props) {
    return {
        name: "monthlyPayment",
        answer: {
            type: "euro",
            validation: {
                min: {value: 100, message: "The minimum value here is €100"},
                max: {value: 5000, message: "The maximum value here is €10,000"}
            },
            step:5
        },
        label: "Current Monthly",
        text: "What is your current monthly repayment?",
        model: "existing"
    }
}

export function outstanding(props) {
    return {
        name: "outstanding",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        label: "Remaining Balance",
        text: "What is the remaining balance on the mortgage",
        model: "existing"
    }
}

export function topUpRequired(props) {
    return {
        name: "topUpRequired",
        label: "Top Up Required",
        text: "Do you require a top-up?",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        model: "existing"
    }
}

export function topUpPurpose(props) {
    return {
        name: "topUpPurpose",
        answer: {
            type: "text",
        },
        hides: {
            topUpRequired: (v) => {
                return v !== true
            }
        },
        label: "Top Up Purpose",
        text: "What is the purpose of this top up?",
        model: "existing"
    }
};
export function topUpAmount(props) {
    return {
        name: "topUpAmount",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            topUpRequired: (v) => {
                return v !== true
            }
        },
        label: "Top Up Amount",
        text: "How much of a top up do you need?",
        model: "existing"
    }
}